module.exports = __webpack_public_path__ + "static/media/korean-categories.597a518b.jpg";